"use strict";
var AddressViewConfig = (function () {
    function AddressViewConfig() {
        // Field validation defaults
        this.address1MaxLength = 50;
        this.address2MaxLength = 50;
        this.cityMaxLength = 40;
        this.stateOrProvinceEnabled = true;
        this.postalCodeLength = 5;
    }
    return AddressViewConfig;
}());
exports.AddressViewConfig = AddressViewConfig;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-config-models/address-view-config.model.js